import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'

import { QA_NAME_CONFIRMATION } from '../../../../../../constants/qa'
import {
  ROUTE_PATH_LIST_RENTAL_PORTAL,
  SUBMENU_DEFAULT_VALUE,
} from '../../../../../../constants/route'
import { ConfirmationModal } from '../../../../../Confirmation'
import {
  getListingArchiveDescription,
  getListingUnitLabel,
  LISTING_ACTION_ARCHIVE,
} from '../../../../../RentalPortalListing'
import { getListingProfileLivePortalNames } from '../../RentalPortalListingProfile.utils'
import { useListingProfileContext } from '../useListingProfileContext'
import { useListingProfilePerformAction } from '../useListingProfilePerformAction'

import ArchiveIcon from '../../../../../../icons/delete.svg'

export function useListingProfileArchiveAction() {
  const navigate = useNavigate()
  const { t } = useTranslation()

  const { handleCloseModal, listingData, setModal } = useListingProfileContext()

  function handleArchiveSuccess() {
    navigate(
      `/${ROUTE_PATH_LIST_RENTAL_PORTAL.root}/${ROUTE_PATH_LIST_RENTAL_PORTAL.listings}`
    )
  }

  const { handlePerformAction } = useListingProfilePerformAction({
    sub: SUBMENU_DEFAULT_VALUE,
    onSuccess: handleArchiveSuccess,
  })

  function handleSubmitArchive() {
    handlePerformAction(LISTING_ACTION_ARCHIVE)
  }

  function handleClickArchive() {
    setModal(
      <ConfirmationModal
        actionButtonsProps={{
          submitProps: { beforeIconProps: { Icon: ArchiveIcon } },
          submitText: t('RentalPortal.ListingArchiveBtnKey'),
        }}
        description={getListingArchiveDescription({
          livePortalNames: getListingProfileLivePortalNames(listingData),
          name: getListingUnitLabel({ listing: listingData, t }),
          t,
        })}
        qaName={QA_NAME_CONFIRMATION}
        onCancel={handleCloseModal}
        onSubmit={handleSubmitArchive}
      />
    )
  }

  return { handleClickArchive }
}
